export const works = [
  {
    id: "w01",
    title: "夜色钢琴曲",
    type: "movie",
    year: 2023,
    genre: "剧情 / 音乐",
    company: "星潮影业",
    director: "松本 遥",
    cast: ["佐山爱", "高桥凉介", "林原诗织"],
    rating: 8.6,
    featured: true,
    synopsis:
      "在一座即将拆迁的老剧院里，失业的钢琴师遇见了一位不愿离开的音乐学院女生。两人用一架走音的旧钢琴，为这座城市的夜晚写下了最后一首曲子。影片以细腻克制的镜头语言，讲述关于告别、坚持与重拾热爱的温柔故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20lonely%20grand%20piano%20under%20a%20single%20warm%20spotlight%20in%20a%20vast%20dark%20empty%20theatre%20with%20deep%20navy%20blue%20shadows%20and%20amber%20highlights%2C%20moody%20minimalist%20editorial%20composition%2C%20soft%20film%20grain%2C%20elegant%20and%20quiet&width=600&height=800&seq=wk-cover-01&orientation=portrait",
  },
  {
    id: "w02",
    title: "深海来信",
    type: "movie",
    year: 2022,
    genre: "悬疑 / 剧情",
    company: "北极光传媒",
    director: "陈子墨",
    cast: ["佐山爱", "中村惠", "周牧"],
    rating: 8.2,
    featured: true,
    synopsis:
      "海洋研究员在一次例行深潜作业中，发现了一段来自三十年前失事船只的录音带。随着信件被逐字解读，一段被海雾掩埋的往事重新浮出水面。影片在冷色调的深海影像与温暖回忆之间反复切换，悬念层层递进。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20deep%20ocean%20surface%20from%20below%20with%20a%20single%20faint%20light%20beam%20piercing%20dark%20teal%20water%2C%20mysterious%20atmospheric%20suspense%20mood%2C%20minimalist%20editorial%20cinematic%20composition%2C%20cool%20tones%20with%20subtle%20mist&width=600&height=800&seq=wk-cover-02&orientation=portrait",
  },
  {
    id: "w03",
    title: "樱花车站",
    type: "tv",
    year: 2024,
    genre: "爱情 / 治愈",
    company: "青空制作",
    director: "小林 优",
    cast: ["佐山爱", "藤井翔太", "木村真央"],
    rating: 8.9,
    episodes: 12,
    featured: true,
    synopsis:
      "一座即将停运的乡间小车站，站务员与常年搭乘末班车的旅客们，在樱花盛开的三个月里彼此靠近。每个人带着自己的遗憾上车，也在这里找到了重新出发的理由。剧集以四季流转为线索，温柔地讲述重逢与告别。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20quiet%20rural%20train%20station%20surrounded%20by%20blooming%20sakura%20trees%20in%20soft%20spring%20light%2C%20warm%20pink%20petals%20against%20pale%20cream%20sky%2C%20gentle%20romantic%20nostalgic%20mood%2C%20minimalist%20elegant%20composition&width=600&height=800&seq=wk-cover-03&orientation=portrait",
  },
  {
    id: "w04",
    title: "雾中灯塔",
    type: "movie",
    year: 2021,
    genre: "剧情 / 文艺",
    company: "远岸影业",
    director: "松本 遥",
    cast: ["佐山爱", "渡边淳", "佐野玲"],
    rating: 8.0,
    synopsis:
      "灯塔看守人的女儿在父亲失踪多年后回到海角，开始整理他留下的日志。迷雾笼罩的每一天，她逐渐读懂了父亲沉默背后的选择。影片以静谧的影像与稀疏的对白，描摹孤独与守护之间的距离。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20solitary%20lighthouse%20standing%20on%20a%20rocky%20cliff%20in%20thick%20grey%20sea%20fog%2C%20cold%20desaturated%20palette%20with%20one%20faint%20amber%20lamp%20glow%2C%20quiet%20melancholic%20literary%20cinematic%20mood%2C%20minimal%20composition&width=600&height=800&seq=wk-cover-04&orientation=portrait",
  },
  {
    id: "w05",
    title: "城市晚风",
    type: "tv",
    year: 2023,
    genre: "都市 / 爱情",
    company: "星潮影业",
    director: "陈子墨",
    cast: ["佐山爱", "李承宇", "朴恩熙"],
    rating: 8.4,
    episodes: 16,
    featured: true,
    synopsis:
      "深夜电台主持人每晚都会接到一个熟悉的陌生来电。白天的她与夜晚的他始终错过，直到一场突如其来的城市停电，让两条平行线第一次交汇。剧集以霓虹夜景为底色，描绘都市人迟来的勇气。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20rain-slick%20city%20street%20at%20night%20with%20warm%20streetlight%20reflections%20and%20deep%20blue%20hour%20skyline%2C%20lonely%20urban%20romantic%20mood%2C%20moody%20bokeh%20lights%2C%20minimalist%20elegant%20cinematic%20composition&width=600&height=800&seq=wk-cover-05&orientation=portrait",
  },
  {
    id: "w06",
    title: "流星的约定",
    type: "movie",
    year: 2024,
    genre: "科幻 / 爱情",
    company: "北极光传媒",
    director: "小林 优",
    cast: ["佐山爱", "藤井翔太", "北川凛"],
    rating: 8.7,
    featured: true,
    synopsis:
      "天文台的观测员在流星雨之夜接收到一段重复出现的信号，而信号内容竟与自己十年前的日记一模一样。为了弄清真相，她踏上了一段跨越时间与记忆的旅程。影片将浪漫与科幻巧妙融合，视觉华丽而不失温度。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20meteor%20shower%20streaking%20across%20a%20deep%20navy%20night%20sky%20above%20a%20lone%20hilltop%20observatory%2C%20glowing%20warm%20meteor%20trails%20with%20subtle%20orange%20accents%2C%20romantic%20sci-fi%20awe%20mood%2C%20minimal%20cinematic%20composition&width=600&height=800&seq=wk-cover-06&orientation=portrait",
  },
  {
    id: "w07",
    title: "无声告白",
    type: "tv",
    year: 2022,
    genre: "家庭 / 剧情",
    company: "青空制作",
    director: "周 牧",
    cast: ["佐山爱", "中村惠", "林原诗织"],
    rating: 8.1,
    episodes: 10,
    synopsis:
      "一位听力渐失的母亲与正值青春期的女儿，用纸笔与表情重新学习对话。在一次次误解与和解之间，两人终于说出了那些年从未出口的告白。剧集以克制的叙事与真实的生活质感打动人心。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20two%20overlapping%20silhouettes%20of%20a%20mother%20and%20daughter%20against%20a%20soft%20warm%20beige%20wall%2C%20gentle%20intimate%20quiet%20mood%2C%20minimalist%20literary%20cinematic%20composition%2C%20subtle%20film%20grain%20and%20warm%20tones&width=600&height=800&seq=wk-cover-07&orientation=portrait",
  },
  {
    id: "w08",
    title: "晴天电影院",
    type: "movie",
    year: 2020,
    genre: "喜剧 / 剧情",
    company: "远岸影业",
    director: "松本 遥",
    cast: ["佐山爱", "渡边淳", "高桥凉介"],
    rating: 7.9,
    synopsis:
      "小镇上最后一家老电影院面临关门，放映员决定用最后一个月，为街坊们免费放映那些被遗忘的旧片。笑声与泪水在放映机的光柱里交织，一整条街的记忆也随之被重新点亮。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20vintage%20small-town%20cinema%20facade%20with%20a%20warm%20glowing%20marquee%20in%20soft%20daylight%2C%20nostalgic%20hopeful%20mood%2C%20cream%20and%20amber%20palette%2C%20minimalist%20elegant%20cinematic%20composition&width=600&height=800&seq=wk-cover-08&orientation=portrait",
  },
  {
    id: "w09",
    title: "彼岸花火",
    type: "tv",
    year: 2021,
    genre: "悬疑 / 剧情",
    company: "青空制作",
    director: "陈子墨",
    cast: ["佐山爱", "佐野玲", "北川凛"],
    rating: 8.3,
    episodes: 14,
    synopsis:
      "花火大会的夜晚，一名少女在河堤边失踪。多年后成为记者的好友重返故乡，试图拼凑那个夏夜的真相。剧集以烟火与暗流交织的小镇为舞台，层层揭开被沉默守护的秘密。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20distant%20fireworks%20blooming%20over%20a%20dark%20river%20embankment%20at%20night%2C%20warm%20orange%20sparks%20reflected%20on%20black%20water%2C%20tense%20mysterious%20emotional%20mood%2C%20minimal%20cinematic%20composition&width=600&height=800&seq=wk-cover-09&orientation=portrait",
  },
  {
    id: "w10",
    title: "追光者",
    type: "movie",
    year: 2024,
    genre: "励志 / 剧情",
    company: "星潮影业",
    director: "小林 优",
    cast: ["佐山爱", "李承宇", "木村真央"],
    rating: 8.5,
    synopsis:
      "一名视力逐渐衰退的摄影师，决定在完全失去光明之前，完成一组关于城市清晨的影像计划。旅途中她遇见了形形色色的追光者，也重新定义了自己与世界的关系。影片温暖而充满力量。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20art%20of%20a%20lone%20figure%20holding%20a%20camera%20silhouetted%20against%20a%20golden%20sunrise%20over%20a%20city%20rooftop%20skyline%2C%20warm%20amber%20and%20soft%20blue%20gradient%20sky%2C%20hopeful%20inspiring%20mood%2C%20minimalist%20cinematic%20composition&width=600&height=800&seq=wk-cover-10&orientation=portrait",
  },
];